import { Suspense } from 'react';
import * as Portal from '@radix-ui/react-portal';
import { ErrorBoundary } from 'react-error-boundary';
import { Skeleton } from '@pairy/pds-react';

import Content from './Content';
import ModalShell from './ModalShell';
import PlanComparisonPanel from './PlanComparisonPanel';

interface Props {
  onOpenChange: (isOpen: boolean) => void;
}

const ProPlanUpgradeModal = ({ onOpenChange }: Props) => {
  return (
    <Portal.Root onClick={(e) => e.stopPropagation()}>
      <ModalShell
        onOpenChange={onOpenChange}
        plans={
          <ErrorBoundary
            fallback={<div>플랜 정보를 가져오는데 실패하였습니다</div>}
            onError={() => {
              alert('플랜 정보를 가져오는 데 실패하여 새로고침을 진행합니다');
              if (location) {
                location.reload();
              }
            }}
          >
            <Suspense fallback={<Skeleton width="95%" height="90%" />}>
              <Content onOpenChange={onOpenChange} />
            </Suspense>
          </ErrorBoundary>
        }
        comparison={<PlanComparisonPanel />}
      />
    </Portal.Root>
  );
};

export default ProPlanUpgradeModal;
